import { Component } from 'react';
import Loader from '../../../../../utils/Loader';
import { ToastContainer } from 'react-toastify';
import ExhibitorHeader from '../../../../../common_components/exhibitor_module_header';
import ExhibitorDrawer from '../../../../../common_components/exhibitor_module_drawer';
import ExhibitorTopMenu from '../../../../../common_components/exhibitor_module_topmenu';
import { withRouter } from '../../../../../utils/withRouter';
import { connect } from 'react-redux';
import { toastError, toastSuccess } from '../../../../../utils/constants';
import {
    getInternetConnectionDetails_action,
    insertUpdateInternetConnection_action,
} from '../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/internetConnection_action/internetConnection_action';
import ConfirmationModal from '../../../../../common_components/confirmationa_modal';
import moment from 'moment';
import $ from 'jquery';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class InternetConnection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isOpenConfirmationModal: false,
            confirmationObj: { message: '', buttonName: '', action: '' },

            // Exhibitor read-only info
            exhDetails: {},

            // Service items table (fetched from DB + existing qty merged)
            serviceList: [],

            // GST
            CurrencyID: 1,
            IsIGST: 0,

            // Agency contact + bank details (from master, read-only)
            contactDetailsList: [],

            // Form fields
            noOfVoucher: '',
            noOfPort: '',
            noOfPublicIP: '',
            duration: '',
            Remark: '',
            Is_Agree: false,
            Is_AgreeErr: '',
            serviceListErr: '',
            noOfVoucherErr: '',
            noOfPortErr: '',
            noOfPublicIPErr: '',
            durationErr: '',

            // Router state
            DeadlineDate: '',
            StatusID: '',
            is_View: false,
            currentDate: moment().format('DD-MM-YYYY'),

            isHideSection: sessionStorage.getItem('RoleIDSS') != 1,
        };

        this.getInternetConnectionDetails = this.getInternetConnectionDetails.bind(this);
        this.handleQtyChange = this.handleQtyChange.bind(this);
        this.calcTotals = this.calcTotals.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleConfirmation = this.handleConfirmation.bind(this);
    }

    componentDidMount() {
        const locState = this.props.location.state;
        this.setState({
            DeadlineDate: locState?.Deadline
                ? moment(locState.Deadline).format('DD-MM-YYYY')
                : '',
            StatusID: locState?.StatusID ?? '',
            is_View: locState?.is_View != null
                ? locState.is_View
                : sessionStorage.getItem('RoleIDSS') != 1,
        });
        this.getInternetConnectionDetails();
        $(document).ready(function () { $(this).scrollTop(0); });
    }

    // ── Fetch service items + existing exhibitor quantities + GST ──────────────
    getInternetConnectionDetails() {
        this.setState({ isLoading: true });
        this.props.getInternetConnectionDetails_action()
            .then((data) => {
                this.setState({ isLoading: false });
                if (data.error != 1) {
                    const exhDetails = data.exhDetails?.[0] || {};
                    const gst = data.gstDetails?.[0] || {};
                    const hdr = data.hdrData?.[0] || {};
                    const CurrencyID = gst.CurrencyID != null ? gst.CurrencyID : 1;
                    const IsIGST = gst.IsIGST != null ? gst.IsIGST : 0;

                    // Map service items; keep existing Quantity and Amount if already saved
                    const serviceList = (data.serviceList || []).map((r) => ({
                        InternetConnectionMasterID: r.InternetConnectionMasterID,
                        InternetConnectionDetailID: r.InternetConnectionDetailID || 0,
                        ServiceItem: r.ServiceItem,
                        InstallationCharges: parseFloat(r.InstallationCharges) || 0,
                        Quantity: r.Quantity != null && r.Quantity != 0 ? r.Quantity : '',
                        Amount: parseFloat(r.Amount) || 0,
                    }));

                    this.setState({
                        exhDetails,
                        serviceList,
                        contactDetailsList: data.contactDetails || [],
                        CurrencyID,
                        IsIGST,
                        noOfVoucher: hdr.noOfVoucher != null ? hdr.noOfVoucher : '',
                        noOfPort: hdr.noOfPort != null ? hdr.noOfPort : '',
                        noOfPublicIP: hdr.noOfPublicIP != null ? hdr.noOfPublicIP : '',
                        duration: hdr.duration != null ? moment(hdr.duration, "YYYY-MM-DD HH:mm").toDate() : '',
                        Remark: hdr.Remark || '',
                        Is_Agree: hdr.Is_Agree || false,
                        StatusID: hdr.StatusID != null ? hdr.StatusID : this.state.StatusID,
                    });
                } else {
                    toastError(data.msg);
                }
            })
            .catch((e) => console.log(e));
    }

    // ── Quantity input change → auto-calculate Amount ─────────────────────────
    handleQtyChange(index, value) {
        const { serviceList } = this.state;
        const updated = serviceList.map((row, i) => {
            if (i !== index) return row;
            const qty = value === '' ? '' : parseInt(value) || 0;
            const amount = qty === '' ? 0 : qty * row.InstallationCharges;
            return { ...row, Quantity: qty, Amount: amount };
        });
        this.setState({ serviceList: updated, serviceListErr: '' });
    }

    // ── Compute subtotal + GST + grand total ──────────────────────────────────
    calcTotals() {
        const { serviceList, IsIGST } = this.state;
        const subTotal = serviceList.reduce(
            (sum, r) => sum + (parseFloat(r.Amount) || 0), 0
        );
        if (IsIGST === 1) {
            return {
                subTotal,
                igst: subTotal * 0.18,
                cgst: 0,
                sgst: 0,
                grandTotal: subTotal * 1.18,
            };
        }
        return {
            subTotal,
            igst: 0,
            cgst: subTotal * 0.09,
            sgst: subTotal * 0.09,
            grandTotal: subTotal * 1.18,
        };
    }

    // ── Validate before submit ────────────────────────────────────────────────
    inputValidate() {
        const { Is_Agree, serviceList, noOfVoucher, noOfPort, noOfPublicIP, duration } = this.state;
        let valid = true;

        const hasAtLeastOneQty = serviceList.some(
            (r) => r.Quantity !== '' && parseInt(r.Quantity) > 0
        );
        if (!hasAtLeastOneQty) {
            this.setState({ serviceListErr: 'Please fill in at least 1 row in the tariff table.' });
            toastError('Please fill in at least 1 row in the WLAN/LAN tariff table.');
            valid = false;
        } else {
            this.setState({ serviceListErr: '' });
        }

        if (!Is_Agree) {
            this.setState({
                Is_AgreeErr: 'Kindly agree to the disclaimer & Service Partner Terms and Conditions.',
            });
            valid = false;
        }

        return valid;
    }

    // ── Confirmation modal handler ────────────────────────────────────────────
    handleConfirmation(flag) {
        if (flag) this.handleSubmit();
        this.setState({ isOpenConfirmationModal: false });
    }

    // ── Submit / Update ───────────────────────────────────────────────────────
    handleSubmit() {
        if (!this.inputValidate()) return;

        const { serviceList, noOfVoucher, noOfPort, noOfPublicIP, duration, Remark, Is_Agree } = this.state;
        const locState = this.props.location.state;
        const ManualFormID = locState?.ManualFormsID || null;
        const ServiceID = locState?.ServiceID || null;
        const VendorDetails = locState?.VendorDetails || {};

        // Only send rows that have a quantity entered (> 0 or existing record)
        const payload = serviceList.map((r) => ({
            InternetConnectionMasterID: r.InternetConnectionMasterID,
            InternetConnectionDetailID: r.InternetConnectionDetailID,
            Quantity: parseInt(r.Quantity) || null,
            Amount: parseFloat(r.Amount) || null,
        }));

        this.setState({ isLoading: true });
        this.props
            .insertUpdateInternetConnection_action(
                payload,
                parseInt(noOfVoucher) || 0,
                parseInt(noOfPort) || 0,
                parseInt(noOfPublicIP) || 0,
                duration || null,
                Remark,
                Is_Agree,
                ManualFormID,
                ServiceID,
                VendorDetails
            )
            .then((data) => {
                this.setState({ isLoading: false });
                if (data.error != 1) {
                    toastSuccess(
                        this.state.StatusID == 0
                            ? 'Internet Connection Form Submitted Successfully'
                            : 'Internet Connection Form Updated Successfully'
                    );
                    setTimeout(() => this.props.navigate('/manualForms'), 2000);
                } else {
                    toastError(data.msg);
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }

    render() {
        const {
            isLoading, isOpenConfirmationModal, confirmationObj,
            exhDetails, serviceList, contactDetailsList, CurrencyID, IsIGST,
            noOfVoucher, noOfPort, noOfPublicIP, duration,
            Remark, Is_Agree, Is_AgreeErr, serviceListErr,
            noOfVoucherErr, noOfPortErr, noOfPublicIPErr, durationErr,
            DeadlineDate, StatusID, is_View, isHideSection, currentDate,
        } = this.state;

        const { subTotal, igst, cgst, sgst, grandTotal } = this.calcTotals();

        const isDeadlinePassed =
            DeadlineDate &&
            moment(currentDate, 'DD-MM-YYYY').isAfter(moment(DeadlineDate, 'DD-MM-YYYY'));

        // All inputs disabled when viewing, deadline passed, or approved
        const isDisabled = is_View || isDeadlinePassed || StatusID == 2;

        const fmt = (n) =>
            parseFloat(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 });

        return (
            <>
                {isOpenConfirmationModal && (
                    <ConfirmationModal
                        onConfirmation={this.handleConfirmation}
                        message={confirmationObj}
                    />
                )}
                {isLoading && <Loader />}
                <ToastContainer />

                {!isHideSection && (
                    <>
                        <ExhibitorHeader />
                        <ExhibitorDrawer />
                    </>
                )}

                <div className={!isHideSection ? 'with-dr-container' : ''}>
                    <div>
                        {!isHideSection && (
                            <div className="row">
                                <ExhibitorTopMenu />
                            </div>
                        )}

                        <div className="exb-top-space">
                            <div className="row mx-2">
                                <div className="card rounded-0 pt-1 shadow-none">

                                    {/* ── Card Header ── */}
                                    <div className="card-header p-2">
                                        <h3 className="card-title" style={{ fontSize: 15 }}>
                                            Internet Connection Booking Form
                                        </h3>
                                    </div>

                                    <div className="card-body p-1 m-2">

                                        {/* ── Disclaimer ── */}
                                        {!isHideSection && (
                                            <ul style={{ lineHeight: '25px', padding: 0, textAlign: 'left' }}>
                                                <li>
                                                    1) The cost/rates and terms &amp; conditions of utilizing the individual
                                                    services from the given service provider is solely at the discretion of
                                                    exhibitors.
                                                </li>
                                                <li>
                                                    2) India ITME Society is only an information facilitator for the service
                                                    provider &amp; in no event shall INDIA ITME SOCIETY be liable for any
                                                    direct, indirect, punitive, incidental, or special consequential issues
                                                    arising out of taking services with the above given service provider.
                                                </li>
                                            </ul>
                                        )}

                                        {/* ── Exhibitor Details ── */}
                                        {!isHideSection && (
                                            <>
                                                <strong><p className="m-0 mb-1">Exhibitor Details:</p></strong>
                                                <div className="table-responsive mb-3">
                                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ width: '30%' }}><strong>Exhibiting Company Name:</strong></td>
                                                                <td>{exhDetails.ExhibitorCompanyName || '-'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>Booth No.:</strong></td>
                                                                <td>{exhDetails.StallName || '-'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>Hall No.:</strong></td>
                                                                <td>{exhDetails.HallName || '-'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>Contact Person:</strong></td>
                                                                <td>{exhDetails.ContactPerson || '-'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>Designation:</strong></td>
                                                                <td>{exhDetails.Designation || '-'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>Mobile:</strong></td>
                                                                <td>{exhDetails.Mobile || '-'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>Email ID:</strong></td>
                                                                <td>{exhDetails.PrimaryEmail || '-'}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* ── Contact Details ── */}
                                                {contactDetailsList.length > 0 && (
                                                    <>
                                                        <strong><p className="m-0 mb-1">Contact Details:</p></strong>
                                                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: 14 }}>
                                                            {contactDetailsList.map((data, i) => (
                                                                <div key={i} className="table-responsive w-50" style={{ backgroundColor: '#ebebeb', marginBottom: 14, borderRight: '1px solid lightgray' }}>
                                                                    <div style={{ margin: '10px 0 10px 10px', lineHeight: '23px' }}>
                                                                        {data.Name && <p className="m-0"><strong>Name:</strong> {data.Name}</p>}
                                                                        {data.Designation && <p className="m-0"><strong>Designation:</strong> {data.Designation}</p>}
                                                                        {data.Phone && <p className="m-0"><strong>Phone:</strong> {data.Phone}</p>}
                                                                        {data.Mobile && <p className="m-0"><strong>Mobile:</strong> {data.Mobile}</p>}
                                                                        {data.Fax && <p className="m-0"><strong>Fax:</strong> {data.Fax}</p>}
                                                                        {data.Email && <p className="m-0"><strong>Email:</strong> {data.Email}</p>}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </>
                                                )}

                                                {/* ── Pointers ── */}
                                                <ul style={{ lineHeight: '25px', textAlign: 'left', marginBottom: '14px', listStyleType: 'disc', paddingLeft: '20px' }}>
                                                    <li style={{ listStyleType: 'disc' }}>
                                                        India Exposition Mart Limited is the authorised official IT Service Provider for India ITME 2026.
                                                    </li>
                                                    <li style={{ listStyleType: 'disc' }}>
                                                        This Form is applicable only for the Exhibitors and not any other parties working directly or indirectly, with or on behalf of exhibitors.
                                                    </li>
                                                </ul>
                                            </>
                                        )}

                                        {/* ── Connection Requirements Table ── */}
                                        {!isHideSection && (
                                            <div className="row mt-3">
                                                <h6>
                                                    Internet Connection Booking Form{" "}
                                                    <span className="text-danger">
                                                        {" "}Last Date Of Submission -{" "}
                                                        {this.props.location?.state?.ActualDeadline
                                                            ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
                                                            : "-"}
                                                    </span>
                                                </h6>
                                            </div>
                                        )}
                                        {!isHideSection && (
                                            <div className="mb-3">
                                                <table className="table border text-md-nowrap table-bordered mb-0">
                                                    <tbody>
                                                        {[
                                                            { label: 'No. Of Public IP (If Any):', key: 'noOfPublicIP', val: noOfPublicIP, err: noOfPublicIPErr },
                                                            { label: 'Duration:', key: 'duration', val: duration, err: durationErr },
                                                        ].map(({ label, key, val, err }) => (
                                                            <tr key={key}>
                                                                <td style={{ width: '60%' }}>
                                                                    <strong>{label}</strong>
                                                                </td>
                                                                <td>
                                                                    {key === "duration" ? (
                                                                        <DatePicker
                                                                            selected={val ? val : null}
                                                                            onChange={(date) =>
                                                                                this.setState({
                                                                                    duration: date,
                                                                                    durationErr: '',
                                                                                })
                                                                            }
                                                                            className={`form-control`}
                                                                            placeholderText="Select duration"
                                                                            dateFormat="dd/MM/yyyy"
                                                                            style={{ maxWidth: 150 }}
                                                                            minDate={new Date()}
                                                                            disabled={isDisabled}
                                                                        />
                                                                    ) : (
                                                                        <input
                                                                            type="number"
                                                                            className={`form-control`}
                                                                            style={{ maxWidth: 150 }}
                                                                            value={val}
                                                                            min={0}
                                                                            disabled={isDisabled}
                                                                            onKeyDown={(e) =>
                                                                                ['e', 'E', '+', '-', '.'].includes(e.key) &&
                                                                                e.preventDefault()
                                                                            }
                                                                            onChange={(e) =>
                                                                                this.setState({
                                                                                    [key]: e.target.value === '' ? '' : parseInt(e.target.value) || 0,
                                                                                    [`${key}Err`]: '',
                                                                                })
                                                                            }
                                                                            placeholder="0"
                                                                        />
                                                                    )}

                                                                    {err && (
                                                                        <span className="text-danger d-block mt-1" style={{ fontSize: 12 }}>
                                                                            {err}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}

                                        {/* ── Service Items + GST Table ── */}
                                        <div className="mb-3">
                                            {!isHideSection && (
                                                <p className="mb-1" style={{ fontSize: 13, color: '#555' }}>
                                                    <span className="text-danger">*</span> Please fill in the quantity for at least 1 service item below.
                                                </p>
                                            )}
                                            <div className="table-responsive">
                                                <table className={`table border text-nowrap text-md-nowrap table-bordered mb-0${serviceListErr ? ' border-danger' : ''}`}>
                                                    <thead>
                                                        <tr>
                                                            <th colSpan={isHideSection ? 3 : 5} className="text-center">
                                                                WLAN/LAN-Wireless/wired Managed IT services Tariff for entire Duration &amp; Day Wise for the event
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-center" style={{ width: 55 }}>Sr. No</th>
                                                            <th>Service Item</th>
                                                            {!isHideSection && (
                                                                <th className="text-center" style={{ width: 200 }}>
                                                                    Installation / Consumption Charges (A)
                                                                    {CurrencyID === 1 ? ' ₹' : ' $'}
                                                                </th>
                                                            )}
                                                            <th
                                                                className="text-center"
                                                                style={{ width: 120, color: serviceListErr ? '#dc3545' : undefined }}
                                                            >
                                                                Qty (B) <span className="text-danger">*</span>
                                                            </th>
                                                            {!isHideSection && (
                                                                <th className="text-center" style={{ width: 160 }}>Amount (A×B)</th>
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {serviceList.length > 0 ? (
                                                            serviceList.map((row, index) => (
                                                                <tr key={row.InternetConnectionMasterID}>
                                                                    <td className="text-center align-middle">{index + 1}</td>
                                                                    <td className="align-middle">{row.ServiceItem}</td>
                                                                    {!isHideSection && (
                                                                        <td className="text-end align-middle">
                                                                            {fmt(row.InstallationCharges)}
                                                                        </td>
                                                                    )}
                                                                    <td className="text-center">
                                                                        <input
                                                                            type="number"
                                                                            className={`form-control text-center${serviceListErr ? ' is-invalid' : ''}`}
                                                                            style={{ minWidth: 80 }}
                                                                            value={row.Quantity}
                                                                            min={0}
                                                                            disabled={isDisabled}
                                                                            onKeyDown={(e) =>
                                                                                ['e', 'E', '+', '-', '.'].includes(e.key) &&
                                                                                e.preventDefault()
                                                                            }
                                                                            onChange={(e) =>
                                                                                this.handleQtyChange(index, e.target.value)
                                                                            }
                                                                            placeholder="0"
                                                                        />
                                                                    </td>
                                                                    {!isHideSection && (
                                                                        <td className="text-end align-middle">
                                                                            {fmt(row.Amount)}
                                                                        </td>
                                                                    )}
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={isHideSection ? 3 : 5} className="text-center text-muted">
                                                                    No service items available. Please contact admin.
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                    {/* ── GST Footer ── */}
                                                    {!isHideSection && (
                                                        <tfoot>
                                                            <tr>
                                                                <td colSpan={4} className="text-end">
                                                                    <strong>Sub Total</strong>
                                                                </td>
                                                                <td className="text-end">
                                                                    <strong>{fmt(subTotal)}</strong>
                                                                </td>
                                                            </tr>

                                                            {IsIGST === 1 ? (
                                                                <tr>
                                                                    <td colSpan={4} className="text-end">IGST @ 18%</td>
                                                                    <td className="text-end">{fmt(igst)}</td>
                                                                </tr>
                                                            ) : (
                                                                <>
                                                                    <tr>
                                                                        <td colSpan={4} className="text-end">CGST @ 9%</td>
                                                                        <td className="text-end">{fmt(cgst)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan={4} className="text-end">SGST @ 9%</td>
                                                                        <td className="text-end">{fmt(sgst)}</td>
                                                                    </tr>
                                                                </>
                                                            )}

                                                            <tr>
                                                                <td colSpan={4} className="text-end">
                                                                    <strong>Grand Total</strong>
                                                                </td>
                                                                <td className="text-end">
                                                                    <strong>{fmt(grandTotal)}</strong>
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                    )}
                                                </table>
                                            </div>
                                            {serviceListErr && (
                                                <span className="text-danger d-block mt-1">{serviceListErr}</span>
                                            )}
                                        </div>

                                        {!isHideSection && (
                                            <div className="mt-3" style={{ textAlign: "left" }}>
                                                <p className="mb-1"><strong>For Above 50 Mbps Dedicated Internet Wired Connection:</strong></p>
                                                <p className="mb-2"><strong>Rs. On Demand Basis</strong></p>

                                                <p className="mb-1"><strong>Terms &amp; Conditions:</strong></p>
                                                <ol style={{ paddingLeft: "20px", lineHeight: "25px" }}>
                                                    <li>Issued voucher is non-refundable and non-exchangeable.</li>
                                                    <li>In accordance with policies of Govt. of India / TRAI / DOT, IEML shall carry out periodic inspections/request for documents pertaining to usage to ensure that there is no misuse of circuit</li>
                                                    <li>The above charges do not include the internal networking wiring at stall. (We are liable only to give wired connectivity drop at a single point)</li>
                                                    <li>Wi-Fi Services may not be accessible at certain spots or at certain point of time within the premises due to the atmospheric and radio interference and any technical limitations applicable to our equipment or your equipment.</li>
                                                </ol>

                                                <p className="mb-1"><strong>Mandatory KYC Documents (Required by DOT, in absence service will not be commissioned)</strong></p>
                                                <ul style={{ listStyleType: "disc", paddingLeft: "20px", lineHeight: "25px" }}>
                                                    <li>MOA of the company or Certificate of Incorporation,</li>
                                                    <li>Company PAN Card</li>
                                                    <li>Billing Address Proof</li>
                                                    <li>ID Proof of Signing Authority</li>
                                                    <li>GST Details</li>
                                                    <li>Please Note: 1 Port is equivalent to 1 Mbps</li>
                                                </ul>

                                                {contactDetailsList.length > 0 && (
                                                    <>
                                                        <p className="mb-1 mt-2"><strong>Payment Term:</strong></p>
                                                        <p style={{ lineHeight: "25px" }}>
                                                            Order Form shall be valid/entertained only when the same be accompanied with full remittance, in favour of India Exposition Mart Limited Payable at Greater Noida, For IMPS/NEFT/RTGS/ Demand Draft/ Cheque bank details is as follows: -
                                                        </p>
                                                    </>
                                                )}

                                                {/* ── Bank Details ── */}
                                                {contactDetailsList.length > 0 && (
                                                    <div className="table-responsive mb-3">
                                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th colSpan={2}>Bank Details</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {contactDetailsList.map((item, i) => (
                                                                    <>
                                                                        {item.Name && <tr key={`name-${i}`}><td><strong>Name:</strong></td><td>{item.Name}</td></tr>}
                                                                        {item.AccountNumber && <tr key={`acc-${i}`}><td><strong>Bank Account Number:</strong></td><td>{item.AccountNumber}</td></tr>}
                                                                        {item.BankName && <tr key={`bank-${i}`}><td><strong>Name of Bank:</strong></td><td>{item.BankName}</td></tr>}
                                                                        {(item.Branch || item.Address) && (
                                                                            <tr key={`addr-${i}`}>
                                                                                <td><strong>Bank Branch and Address:</strong></td>
                                                                                <td>{item.Branch && item.Branch !== '-' ? `${item.Branch}, ` : ''}{item.Address || ''}</td>
                                                                            </tr>
                                                                        )}
                                                                        {item.RTGS_IFSC && <tr key={`ifsc-${i}`}><td><strong>RTGS/IFSC Code:</strong></td><td>{item.RTGS_IFSC}</td></tr>}
                                                                        {item.PAN && <tr key={`pan-${i}`}><td><strong>PAN:</strong></td><td>{item.PAN}</td></tr>}
                                                                        {item.GST && <tr key={`gst-${i}`}><td><strong>GST:</strong></td><td>{item.GST}</td></tr>}
                                                                        {i < contactDetailsList.length - 1 && (
                                                                            <tr>
                                                                                <td colSpan={2} style={{ backgroundColor: '#f0f0f0', padding: '4px' }} />
                                                                            </tr>
                                                                        )}
                                                                    </>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                    </div>{/* card-body */}
                                </div>
                            </div>

                            {/* ── Additional Note + Is_Agree ── */}
                                <div className="row m-1 mt-2">
                                    <div>
                                        <strong><label>Additional Note</label></strong>
                                        <textarea
                                            className="form-control"
                                            value={Remark}
                                            disabled={isDisabled}
                                            onChange={(e) => this.setState({ Remark: e.target.value })}
                                            maxLength={300}
                                            rows={3}
                                        />
                                    </div>
                                    <div className="mt-2">
                                        <label className="d-flex">
                                            <input
                                                type="checkbox"
                                                checked={Is_Agree}
                                                disabled={isDisabled}
                                                onChange={(e) =>
                                                    this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: '' })
                                                }
                                            />
                                            <strong className="ms-1">
                                                I agree to the above disclaimer &amp; Service Partner Terms and
                                                Conditions mentioned in the Guideline
                                                <span className="required">*</span>.
                                            </strong>
                                        </label>
                                        {Is_AgreeErr && (
                                            <span className="text-danger d-block mt-1">{Is_AgreeErr}</span>
                                        )}
                                    </div>
                                </div>

                            {/* ── Deadline warning ── */}
                            {isDeadlinePassed && (
                                <div className="row mx-1">
                                    <span className="text-danger fw-bold">
                                        THE DEADLINE TO FILL OUT THIS FORM HAS PASSED.
                                    </span>
                                </div>
                            )}

                            {/* ── Action Buttons ── */}
                            {!isHideSection && (
                                <div className="d-flex gap-1 justify-content-end mt-2 mb-3 me-2">
                                    <button
                                        type="button"
                                        className="btn btn-aqua rounded-1"
                                        disabled={isDisabled}
                                        onClick={() =>
                                            this.setState({
                                                isOpenConfirmationModal: true,
                                                confirmationObj: {
                                                    message: `Do you want to ${StatusID == 0 ? 'Submit' : 'Update'}?`,
                                                    buttonName: StatusID == 0 ? 'Submit' : 'Update',
                                                    action: 0,
                                                },
                                            })
                                        }
                                    >
                                        {StatusID == 0 ? 'Submit' : 'Update'}
                                    </button>
                                    <button
                                        className="btn btn-gray rounded-1"
                                        onClick={() => window.history.back()}
                                    >
                                        Back
                                    </button>
                                </div>
                            )}

                        </div>{/* exb-top-space */}
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(
    connect(null, {
        getInternetConnectionDetails_action,
        insertUpdateInternetConnection_action,
    })(InternetConnection)
);
